/* eslint-disable eqeqeq */
import React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import FormHelperText from '@mui/joy/FormHelperText';
import ClickAwayListener from '@mui/base/ClickAwayListener';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

type OptionType = any;

interface Props {
  id?: string;
  clg?: boolean;
  borderless?: boolean;
  label?: string;
  option: OptionType;
  mdCol?: string | number;
  name?: string;
  values?: any;
  onChange?: (e: any, child?: React.ReactNode) => void;
  isValid?: boolean;
  feedback?: any;
  defautlValues?: any;
  disabled?: boolean;
  placeholder?: string;
  form?: any;
  className?: string;
  multiple?: boolean;
  logo?: string;
  hidden?: boolean;
  borderType?: number;
  readOnly?: boolean;
  isMissing?: any;
  isLongLableText?: boolean;
  setLabelHight?: boolean;
  isCMLogo?: boolean
  isUcCsuLogo?: boolean;
  isSatTest?: boolean;
  renderValue?: (selected: any) => React.ReactNode;
  labelClass? : string;
  labelCustom? : any;
  /** When true, do not auto-set the first option when the value is empty (e.g. required picklists). */
  disableAutoSelectFirst?: boolean;
}

const DropDownInput = (props: Props) => {
  React.useEffect(() => {
    if (
      !props.disableAutoSelectFirst &&
      props.option?.length &&
      (props.values === undefined || props.values === null || props.values === '')
    ) {
      props.form &&
        props.form.setFieldValue(
          props.name,
          typeof props.option[0] === 'string' ? props.option[0] : props.option[0]?.value
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.values]);

  // Manage dropdown open state for outside-click close behavior
  const [isListboxOpen, setIsListboxOpen] = React.useState<boolean>(false);

  // let className = "ps-1 pe-2 py-2";

  // Fix className content justify-content-xxx
  // if (props.className?.includes('justify-content-')) {
  //   className = className.replace('justify-content-end ', '');
  // }

  // if (!props.className?.includes("py-") && !props?.className?.includes("px-")) {
  //   className = `ps-1 pe-2 py-2 ${props.className ?? ''}`.trim();
  // }
  // else {
  //   if (props.className?.includes("py-")) {
  //     className = className.replace('py-2', props.className);
  //   }
  //   if (props?.className?.includes("px-")) {
  //     className = className.replace('ps-1 pe-2', props.className);
  //   }
  // }

  // let selectClass = props?.readOnly ? 'select-readonly' : undefined;

  // Xử lý renderValue cho multiple
  const renderValue = props.renderValue || ((selected: any) => {
    // Xử lý khi selected là object từ MUI Joy Select
    let selectedValue = selected;
    if (selected && typeof selected === 'object' && selected.value !== undefined) {
      selectedValue = selected.value;
    }

    if (props.multiple === true) {
      if (Array.isArray(selected) && selected.length > 0) {
        if (selected[0] && typeof selected[0] === 'object' && selected[0].name) {
          return selected.map((s: any) => s.name).join(', ');
        }
        return selected.join(', ');
      }
      return '';
    } else {
      if (typeof selectedValue === 'string') {
        return selectedValue.charAt(0).toUpperCase() + selectedValue.slice(1);
      }
      if (typeof selectedValue === 'object' && selectedValue) {
        if (props.option && props.option.length > 0) {
          if (
            props.option[0]?.hasOwnProperty('value') &&
            props.option[0]?.hasOwnProperty('name')
          ) {
            const name = props.option.find((opt: any) => opt?.value === selectedValue)?.name;
            return name ?? '';
          }
          if (
            props.option[0]?.hasOwnProperty('id') &&
            props.option[0]?.hasOwnProperty('name')
          ) {
            let val = props.option.find((opt: any) => opt?.id === selectedValue)?.name;
            return val ?? '';
          }
        }
        return selectedValue?.name || selectedValue?.value;
      }
      return selectedValue;
    }
  });

  return props.hidden ? null : (
    <FormControl
      id={props.id}
      disabled={props.disabled}
      error={!!props.isMissing}
      className={props.className}
    >
      {props.labelCustom!==undefined ? (
      <label htmlFor={props.id || props.name} className = {props.labelClass} >
        {props.label}
        {props.labelCustom && (props.labelCustom)}
      </label>      
      ) : (
      <div
        style={
          props.setLabelHight
            ? {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                minHeight: '40px',
              }
            : { 
              marginBottom: '2px' 
            }
        }
      >
        <FormLabel
          className={`label-14px p-0 ${props.labelClass}`}
          sx={{
            // display: 'flex',
            display: 'inline',
            alignItems: 'center',
            fontSize: '14px',
            margin: props.setLabelHight ? 0 : undefined,
            marginBottom: '1px !important',
            backgroundColor: props.isMissing ? '#FFEBEB' : '',

          }}
        >
          <span>{props.label}</span>
          {(props?.logo && props.setLabelHight) && (
            <FormLabel className={`csu-logo-select-input-float-right ${props?.logo ?? ''}`.trim()} />
          )}
        </FormLabel>
        {(props?.logo && !props.setLabelHight && !props.isSatTest && !props.isUcCsuLogo) ? <span className={`cm-logo-select-input-float-right ${props?.logo ?? null}`}></span> : null}
        {(props?.logo && props.isSatTest) ? <span className={`csu-logo-sat-test-right ${props?.logo ?? null}`}></span> : null}
        {(props?.logo && props.isUcCsuLogo) ? <span className={`csu-logo-cu-csu-right ${props?.logo ?? null}`}></span> : null}
      </div>

      )}

      <ClickAwayListener onClickAway={() => setIsListboxOpen(false)}>
        <div>
          <Select
            indicator={<KeyboardArrowDownIcon />}
            name={props.name}
            value={props.values ?? (props.multiple ? [] : '')}
            onChange={(e, newValue) => {
              if (props.form) {
                props.form.setFieldValue(props.name, newValue);
              }
              if (props.onChange) {
                props.onChange({
                  target: {
                    name: props.name,
                    value: newValue,
                  },
                });
              }
            }}
            placeholder={props.placeholder}
            multiple={props.multiple}
            disabled={props.disabled}
            // readOnly={props.readOnly}
            component="div"
            variant="outlined"
            size="md"
            sx={{
              backgroundColor: '#fff',
              borderRadius: '0.5rem',
              height: '50px',
              minHeight: '50px',
              fontSize: '16px',
              fontWeight: 400,
              paddingLeft: '20px',
              paddingRight: '14px',
              boxSizing: 'border-box',
              paddingBottom: '0!important',
              paddingBlockEnd: '0!important',
              lineHeight: '1.5',
              '& .MuiSelect-button': {
                display: 'flex',
                alignItems: 'center',
                height: '100%',
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                minHeight: 'unset',
                lineHeight: '1.5',
                fontSize: '14px',
              },
            }}
            // Control listbox open state so we can close on outside click
            listboxOpen={isListboxOpen}
            onListboxOpenChange={(open: boolean) => setIsListboxOpen(open)}
            renderValue={renderValue}
          >
            {(props.option ?? []).map((opt: any, index: number) => {
              if (opt === undefined || opt === null || opt === '') {
                return (
                  <Option key={index} value={opt}>
                    {opt}
                  </Option>
                );
              } else if (typeof opt === 'string' || typeof opt === 'number') {
                return (
                  <Option key={index} value={opt}
                    sx={{
                      paddingLeft: '20px',
                      '&[aria-selected="true"]': {
                        backgroundColor: '#1967d2!important',  //'#1d4ed8', rgb(25, 103, 210);
                        color: 'white',
                      },
                      '&[aria-selected="true"]:hover': {
                        backgroundColor: '#1967d2!important',
                      },
                      '&:hover': {
                        backgroundColor: 'rgba(25, 103, 210, 0.7)!important',
                        color: '#ffff!important',
                      }
                    }}
                  >
                    {opt}
                  </Option>
                );
              } else {
                return (
                  <Option key={index} value={opt?.id || opt?.value}>
                    {opt?.name || opt?.value}
                  </Option>
                );
              }
            })}
          </Select>
        </div>
      </ClickAwayListener>
      {props.feedback && (
        <FormHelperText>{props.feedback}</FormHelperText>
      )}
    </FormControl>
  );
};

export default DropDownInput;
